import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import InternalStatusModalUI from './InternalStatusModalUI.js'

class InternalStatusModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      internalStatus: this.props.selectedFile && this.props.selectedFile.internalStatus || '',
      internalStatusError: null,
      //
      internalMessage: '',
      internalMessageError: null,
      //
      dueDate: this.props.selectedFile && this.props.selectedFile.dueDateISO || '',
      dueDateError: null,
      //
      cureDate: this.props.selectedFile && this.props.selectedFile.cureDateISO || '',
      cureDateError: null,
      //
      alertIntervalDays: this.props.selectedFile && this.props.selectedFile.alertsIntervalDays || '',
      alertIntervalDaysError: null,
      //
      nextDueDate: '',
      nextDueDateError: null,
      //
      fileName: this.props.selectedFile && this.props.selectedFile.fileName || '',
      fileNameError: null
    }
  }

  render() {
    let internalStatusList = [
      { key: 'complied', value: 'Complied' },
      { key: 'not_complied', value: 'Not complied' },
      { key: 'not_applicable', value: 'Not applicable' }
    ]
    return (
      <InternalStatusModalUI
        context={this.props.context}
        selectedFileCode={this.props.selectedFileCode}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        internalStatusList={internalStatusList}
        internalStatus={this.state.internalStatus}
        onInternalStatusChange={(event) => { this.setState({ internalStatus: event.target.value }) }}
        internalStatusError={this.state.internalStatusError}
        setInternalStatusError={(error) => { this.setState({ internalStatusError: error }) }}
        //
        internalMessage={this.state.internalMessage}
        onInternalMessageChange={(event) => { this.setState({ internalMessage: event.target.value }) }}
        internalMessageError={this.state.internalMessageError}
        setInternalMessageError={(error) => { this.setState({ internalMessageError: error }) }}
        //
        dueDate={this.state.dueDate}
        onDueDateChange={(selectedDateISO) => { this.setState({ dueDate: selectedDateISO }) }}
        dueDateError={this.state.dueDateError}
        setDueDateError={(error) => { this.setState({ dueDateError: error }) }}
        //
        cureDate={this.state.cureDate}
        onCureDateChange={(selectedDateISO) => { this.setState({ cureDate: selectedDateISO }) }}
        cureDateError={this.state.cureDateError}
        setCureDateError={(error) => { this.setState({ cureDateError: error }) }}
        //
        alertIntervalDays={this.state.alertIntervalDays}
        onAlertIntervalDaysChange={(event) => { this.setState({ alertIntervalDays: event.target.value }) }}
        alertIntervalDaysError={this.state.alertIntervalDaysError}
        setAlertIntervalDaysError={(error) => { this.setState({ alertIntervalDaysError: error }) }}
        //
        nextDueDate={this.state.nextDueDate}
        onNextDueDateChange={(selectedDateISO) => { this.setState({ nextDueDate: selectedDateISO }) }}
        nextDueDateError={this.state.nextDueDateError}
        setNextDueDateError={(error) => { this.setState({ nextDueDateError: error }) }}
        //
        fileName={this.state.fileName}
        onFileNameChange={(event) => { this.setState({ fileName: event.target.value }) }}
        fileNameError={this.state.fileNameError}
        setFileNameError={(error) => { this.setState({ fileNameError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let selectedfile = this.props.selectedFile;
    if (!selectedfile || (prevProps.selectedFile && prevProps.selectedFile.fileCode === selectedfile.fileCode)) {
      return;
    }

    // Get the disbursement date from the selected file or fallback to loan disbursement date
    const disbursementDate = selectedfile.disbursementDate || this.props.loan.disbursement.dateISO;

    // Calculate the due date as 15 days after disbursement date
    if (disbursementDate) {
      const dueDate = new Date(disbursementDate);
      dueDate.setDate(dueDate.getDate() + 15); // Add 15 days
      this.setState({
        internalStatus: selectedfile.internalStatus,
        dueDate: dueDate.toISOString().split('T')[0], // Format to YYYY-MM-DD (ISO format)
        cureDate: selectedfile.cureDate, // Format to YYYY-MM-DD (ISO format)
        alertIntervalDays: selectedfile.alertsIntervalDays,
        nextDueDate: selectedfile.nextDueDate,
        fileName: selectedfile.fileName
      });
    }
  }


  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/compliances/${this.props.selectedFileCode}/internalStatus`,
      this.onSubmitCallback, {
      internalStatus: this.state.internalStatus,
      internalMessage: this.state.internalMessage,
      dueDate: this.state.internalStatus === 'complied' ? null : this.state.dueDate,
      cureDate: this.state.cureDate,
      alertIntervalDays: this.state.internalStatus === 'complied' ? null : this.state.alertIntervalDays,
      nextDueDate: this.state.internalStatus === 'complied' ? this.state.nextDueDate : null,
      fileName: this.state.fileName
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 10)
    }
  }

  // onCancelClick = () => {
  //   this.setState({ internalStatus: '', internalMessage: '', dueDate: '', alertIntervalDays: '' })
  //   this.props.onCancelClick()
  // }


  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(InternalStatusModalSF)
